import React, { useState, useEffect } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { showPack } from '~/config/routes';
import Request from '~/providers/Request';
import PackRecord from '~/records/PackRecord';
import { packageOptions } from '~/config/constants';

import Form from './Form';

function EditRecord({ history }) {
  const [record, setRecord] = useState(new PackRecord());
  const [loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id) {
      setLoading(true);
      Request.get(`/admin/packs/${id}`, {})
        .then((response) => {
          setLoading(false);
          const packs = [];
          const specialties = [];
          if (response.data.pack_packages) {
            response.data.pack_packages.map((item) => {
              if (item.specialty_id === null) {
                packs.push({
                  id: item.pack_type,
                  name: packageOptions[item.pack_type],
                });
              }
              if (item.specialty_id !== null) {
                specialties.push(item.specialty);
              }
            });
          }
          setRecord(
            record.updateAttributes({
              ...response.data,
              packs: packs,
              specialties: specialties,
            })
          );
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  async function onSubmit() {
    const data = record.toParams({ doctor: true });
    Request.put(`/admin/packs/${id}`, data, {}, { controller: 'packs' })
      .then((resp) => {
        setLoading(false);
        history.push(showPack.reverse(resp.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes = {
  history: historyPropType,
};

export default EditRecord;
